import { render, staticRenderFns } from "./KontoLibrus.vue?vue&type=template&id=6768c640&scoped=true"
import script from "./KontoLibrus.vue?vue&type=script&lang=js"
export * from "./KontoLibrus.vue?vue&type=script&lang=js"
import style0 from "./KontoLibrus.vue?vue&type=style&index=0&id=6768c640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6768c640",
  null
  
)

export default component.exports